import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import BookCard from './BookCard';

export default function BookCarousel({ books, badgeOverride }) {
  return (
    <Swiper
      modules={[]}
      spaceBetween={24}
      slidesPerView={2.3}
      breakpoints={{
        480: { slidesPerView: 2.6 },
        640: { slidesPerView: 3.3 },
        768: { slidesPerView: 3.8 },
        1024: { slidesPerView: 4.3 },
        1280: { slidesPerView: 5.3 },
      }}
      className="!overflow-visible"
    >
      {books.map((book, i) => (
        <SwiperSlide key={book.id}>
          <BookCard book={book} index={i} badgeOverride={badgeOverride} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
